
import { useRoles, CustomRole } from '@/hooks/useRoles';
import { Label } from '@/components/ui/label';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui/skeleton';

interface RoleAssignmentSectionProps {
  selectedRoles: string[];
  onRoleToggle: (roleId: string) => void;
}

export const RoleAssignmentSection = ({ selectedRoles, onRoleToggle }: RoleAssignmentSectionProps) => {
  const { data: roles, isLoading } = useRoles();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-slate-800 border-b pb-2">تعيين الأدوار</h3>
      <div className="space-y-2">
        <Label>الأدوار المتاحة</Label>
        <div className="flex flex-wrap gap-2">
          {isLoading ? (
            Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} className="h-6 w-20 rounded-full" />)
          ) : (
            roles?.map((role: CustomRole) => {
              const isSelected = selectedRoles.includes(role.id);
              return (
                <Badge
                  key={role.id}
                  onClick={() => onRoleToggle(role.id)}
                  className={cn(
                    "cursor-pointer transition-all border",
                    isSelected ? 'opacity-100' : 'opacity-60 hover:opacity-100'
                  )}
                  style={{ 
                    backgroundColor: isSelected ? role.color : '#f1f5f9',
                    color: isSelected ? 'white' : '#1e293b',
                    borderColor: isSelected ? role.color : '#f1f5f9'
                  }}
                >
                  {role.name}
                </Badge>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};
